import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaInvoiceDEData } from "@/src/types/admissionOffice";
import type { InvoiceDoubleLangCountry, InvoiceSecondLangCode } from "./invoiceLetterDoubleLangRegistry";
import { MALTA_UZB_RUSSIAN_SIGNATURE } from "@/src/constants/AdmissionOffice/Malta/AOMaltaUzbConsts";

const emptyState = (): AOPMaltaInvoiceDEData => ({
  currentDate: "",
  fullName: "",
  dateOfBirth: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  duration: "",
  mediumOfInstruction: "",
  coursePrefix: "",
  invoiceBody: [],
  invoiceBodySecondLanguage: [],
  nationalitySecondLanguage: "",
  courseSecondLanguage: "",
  mediumOfInstructionSecondLanguage: "",
  durationSecondLanguage: "",
});

export interface AOPInvoiceLetterDoubleLangLayoutProps {
  country: InvoiceDoubleLangCountry;
  secondLang: InvoiceSecondLangCode;
}

const AOPInvoiceLetterDoubleLangLayout = ({ country, secondLang }: AOPInvoiceLetterDoubleLangLayoutProps) => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaInvoiceDEData>(emptyState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaInvoiceDEData>(emptyState);
  const [withQR, setWithQR] = useState(true);
  const [selectedSignature, setSelectedSignature] = useState(
    secondLang === "uzb" ? MALTA_UZB_RUSSIAN_SIGNATURE : "Fedorova Anzhelika",
  );

  return (
    <div className="container admission-office-page">
      <AOPConfig
        country={country}
        secondLang={secondLang}
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
        setWithQRForPreview={setWithQR}
        setSelectedSignatureForPreview={setSelectedSignature}
      />
      <AOPPrev
        country={country}
        secondLang={secondLang}
        bodyForPrev={bodyForPrev}
        withQR={withQR}
        selectedSignature={selectedSignature}
      />
    </div>
  );
};

export default AOPInvoiceLetterDoubleLangLayout;
